<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="form-group">
                    <label for="itemname">Creditor</label>
                    <select
                        v-model="selectedCreditorId"
                        id="creditbureau"
                        name="creditbureau"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid' : creditorError}"
                        required
                    >
                        <option v-for="creditor in creditors" v-bind:value="creditor.id">{{ creditor.creditor_name }}</option>
                    </select>
                    <span v-if="creditorError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-9 col-md-9 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditorId" hidden>
                                <div id="editor">
                                </div>
                                <div ref="editorRefSingle" hidden>
                                    <div class="page">
                                        <p>
                                            Federal Trade Commission
                                            <br />
                                            Consumer Response Center
                                            <br />
                                            600 Pennsylvania Ave. NW
                                            <br />
                                            Washington, DC 20580
                                            <br />
                                            <br />
                                            Date: {{ date }}
                                            <br />
                                            <br /> To Whom It May Concern:
                                        </p>
                                        <p>
                                            This letter is a formal complaint against <strong>{{ selectedCreditor.creditor_name }}</strong> in regards to an account #<strong>{{ disputedCreditor.account_number }}</strong>. They have repeatedly violated my rights as well as the Fair Credit Reporting and the Fair Credit Billing Acts. Despite the several correspondences I’ve had with them, they continue reporting inaccurate and unverifiable derogatory information about me to the three major credit reporting agencies – Experian, Equifax, and TransUnion.
                                        </p>
                                        <p>
                                            I have requested <strong>Verification</strong> of this debt per my consumer rights pursuant to the Fair Credit Billing Act. They have allegedly verified this account several times electronically to the credit bureaus but never once to me as mandated by law.
                                        </p>
                                        <p>
                                            REASONS FOR COMPLAINT:
                                            <br />
                                            <ol>
                                                <li>
                                                    there are two accounts, in particular which they just refuse to investigate <strong>{{ selectedCreditor.creditor_name }}</strong>, yet they turn around and tell me that these accounts were verified by the Creditor. However, I've contacted some of the creditors and they have no record of a dispute verification request from this or any other agency regarding an account for me.
                                                </li>
                                                <li>
                                                    I've actually disputed with <strong>{{ selectedCreditor.creditor_name }}</strong> several times directly who simply refuses to validate the debt they claim I owe as requested per the FDCPA. I'm even in dispute with them via the Better Business Bureau. And I've sent every piece of proof that both Experian and TransUnion could possibly need to correct this erroneous information on my credit report yet they refuse to do so.
                                                </li>
                                                <li></li>
                                            </ol>
                                        </p>
                                        <p>
                                            That being said, I feel as though I am being viciously attacked by this company and my consumer rights are being violated left and right. I'm well aware of other previous complaints against this company. So my question is, where does it stop? And does your commission have any plans to prevent unlawful business practices such as this from happening in the future?
                                            <br />
                                            <br />
                                            Please investigate the practices, FCBA, & FCRA violations of this company. I'm requesting that this company is disciplined accordingly for their willful and blatant disregard for the law and also that you REQUIRE them to remove the disputed account in question from my credit reports. This causes serious harm not only to my ability to establish credit and good interest rates, but also to my character as a Professional.
                                            <br />
                                            <br />
                                            If there's anything I can send you to support my claim, please do not hesitate to let me know. Thank you in advance for your immediate attention to this very serious matter.
                                        </p>
                                        <p>
                                            Sincerely,
                                            <br />
                                            <br />
                                            {{ userInfo.firstname }} {{ userInfo.lastname }}
                                            <br />
                                            {{ userInfo.address }}
                                            <br />
                                            {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                                            <br />
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-primary m-1" type="submit">Create Letter</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed } from 'vue'
  import { ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        routes: {
            type: [Array, Object]
        },
        csrf: {
            type: String
        },
        propCreditors: {
            type: [Array, Object]
        },
        propUserInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        const selectedCreditorId = ref(props.propCreditors[0].id);
        const editorRefSingle = ref(null);
        const isInputFormActive = ref(true),
            creditorError = ref(false),
            date = ref(null);
        return {
            creditors: props.propCreditors,
            userInfo: props.propUserInfo,
            selectedCreditorId,
            editorRefSingle,
            isInputFormActive,
            creditorError,
            date,
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const disputedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          disputedCreditor
        };
    },
    created() {
        // console.log(this.creditors);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditorList();
    },
    computed: {
        // a computed getter
        selectedCreditor() {
            return this.creditors.find((attribute) => {
                if (attribute.id == this.selectedCreditorId) {
                    return attribute;
                }
            })
        }
    },
    methods: {
      dispute: function (id) {
        this.disputedCreditor = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditorId == null || this.selectedCreditorId == "null") {
            this.creditorError = true;
        }
        else {
            this.creditorError = false;
        }
        return !this.creditorError;
      },
      getCreditorList: function () {
        axios.get(this.routes.creditorListUrl).then(response => {
                this.rows = response.data.data
            }
        );
      }
    }
  };
</script>